var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { TAutoComplete } from "../../TAutoComplete";
import { SelectFromListSource } from "./SelectFromListSource";
import { jsx as _jsx } from "react/jsx-runtime";
var defaultValueId = -1;
var blankValue = { id: defaultValueId, label: "(blank)", name: "(blank)" };
export function SelectFromListCell(props) {
    var _this = this;
    var listSource = useState(function () { return new SelectFromListSource(); })[0];
    var _a = useState(), defaultValue = _a[0], setDefaultValue = _a[1];
    useEffect(function () { if (!props.value) {
        setDefaultValue(blankValue);
        return;
    } var cancelled = false; (function () { return __awaiter(_this, void 0, void 0, function () { var list, v, e_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, listSource.get("", props.listSource)];
            case 1:
                list = _a.sent();
                if (cancelled)
                    return [2 /*return*/];
                v = list.filter(function (v) { return v.id === props.value; });
                if (v.length === 0) {
                    setDefaultValue(Object.assign({}, blankValue, { name: props.value }));
                    return [2 /*return*/];
                }
                setDefaultValue({ id: v[0].id, name: v[0].label });
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                console.error(e_1);
                setDefaultValue(Object.assign({}, blankValue, { name: props.value }));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); })(); return function () { cancelled = true; }; }, [listSource, props.listSource, props.value]);
    if (defaultValue === undefined)
        return null;
    return /*#__PURE__*/ _jsx(TAutoComplete, { autoFocus: true, noBottomPadding: true, onCancel: function () { return props.onCancel(); }, freeSolo: !props.strictList, fetcher: function (opt) { return __awaiter(_this, void 0, void 0, function () { var srcList, list, search, add; return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, listSource.get("", props.listSource)];
                case 1:
                    srcList = _a.sent();
                    if (srcList.indexOf(blankValue) === -1) {
                        srcList.unshift(blankValue);
                    }
                    list = srcList;
                    search = opt.search.toLowerCase();
                    if (search !== "") {
                        list = list.filter(function (s) { return s.label.toLowerCase().indexOf(search) !== -1; });
                    }
                    if (list.length <= 1) {
                        add = srcList.slice(0, 5).filter(function (s) { return list.indexOf(s) === -1; });
                        list.push.apply(list, add);
                    }
                    return [2 /*return*/, list.map(function (l) { return ({ id: l.id, name: l.label }); })];
            }
        }); }); }, label: "", type: "standard", initialValue: defaultValue, onKeyDown: function (e) { if (e.key === "Tab") {
            e.preventDefault();
            props.onChange(props.value, { tab: e.shiftKey ? -1 : 1 });
        } }, onChange: function (v) { var id = v.id; if (!props.strictList) {
            if (id === defaultValueId) {
                id = v.name;
            }
        } props.onChange(id, { tab: 1 }); } });
}
